// extracted by mini-css-extract-plugin
export default {"container":"hZ-z","title":"iZ-z","link":"jZ-z"};